import { ApiResponse } from '@myrealtrip/fetch';

import DomainManager from '../../shared/utils/DomainManager';
import mrtAxiosV2 from '../../shared/utils/mrtAxiosV2';

import { NotificationItem, NotificationQuery } from '../../constants/notification';

const NOTIFICATION_API_PATH = '/notification-api/api/notifications';

export type NotificationListResponse = {
  hasNext: boolean;
  notificationInfos: NotificationItem[];
};

export const fetchNotifications = (data: NotificationQuery | null, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);
  const defaultQuery = { exceptCommunityNotification: true };

  return mrtAxiosV2(targetEnv, { isWebView: false }).get<ApiResponse<NotificationListResponse>>(
    `${domainManager.getApiDomain()}${NOTIFICATION_API_PATH}`,
    {
      params: data ? { ...data, ...defaultQuery } : defaultQuery,
    },
  );
};

export const markAsReadNotification = (id: number, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);
  return mrtAxiosV2(targetEnv, { isWebView: false }).put(
    `${domainManager.getApiDomain()}${NOTIFICATION_API_PATH}/${id}/read`,
  );
};

export type HasFreshNotificationResponse = {
  newExists: boolean;
};

export const fetchHasFreshNotification = (targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return mrtAxiosV2(targetEnv, { isWebView: false }).get<ApiResponse<HasFreshNotificationResponse>>(
    `${domainManager.getApiDomain()}${NOTIFICATION_API_PATH}/newExists`,
    {
      params: { exceptCommunityNotification: true },
    },
  );
};
